@if (formGroup) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>Parameters</mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="formGroup">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label">Name</label>
            </div>
            <clickatell-form-validation [controlName]="'name'" [form]="formGroup"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="formGroup"
                   [formControlName]="'name'" placeholder="Enter name"/>
          </div>

          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label">Description</label>
            </div>
            <clickatell-form-validation [controlName]="'description'" [form]="formGroup"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="formGroup"
                   [formControlName]="'description'" placeholder="Enter description"/>
          </div>

          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label">Contact Type</label>
            </div>
            <clickatell-form-validation [controlName]="'contactType'" [form]="formGroup"></clickatell-form-validation>
            <select class="control-input" formControlName="contactType"
                    (change)="onContactTypeChange($any($event.target).value)">
              <option value="lookup">Lookup</option>
              <option value="insert">Insert</option>
            </select>
          </div>

          @switch (contactType) {
            @case ('insert') {
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label">MSISDN</label>
                </div>
                <clickatell-form-validation [controlName]="'msisdn'" [form]="formGroup"></clickatell-form-validation>
                <input class="control-input" activeForm [activeForm]="formGroup"
                       [formControlName]="'msisdn'" placeholder="Enter MSISDN"/>
              </div>

              <div class="toggle-field">
                <label class="control-label">Resume Original Flow</label>
                <mat-slide-toggle class="toggle-btn" [color]="'primary'" [formControlName]="'useReturnFlow'" id="useReturnFlow">
                </mat-slide-toggle>
              </div>
            }
          }
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>

    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>Logic</mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="formGroup">
          @if (!formGroup.get('useReturnFlow').value || contactType !== 'insert') {
            <div class="control-result">
              <div class="control-result-header">Yes</div>
              <div class="control-result-container">
                <div class="control-div">
                  <label class="control-label">
                    <span class="pont-to">Point To</span>
                    <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                  </label>
                  @if (nodeFlowDetails) {
                    <next-selector [canEditFlows]="canEdit.canEditFlows"
                                   [selectorType]="'both'"
                                   [flowSteps]="nodeFlowDetails.currentFlowSteps"
                                   [flows]="nodeFlowDetails.flows"
                                   [name]="'yes'"
                                   [form]="formGroup"
                                   [stepId]="nodeFlowDetails.stepId">
                    </next-selector>
                  }
                </div>
              </div>
            </div>
          }
          <div class="control-result">
            <div class="control-result-header">No</div>
            <div class="control-result-container">
              <div class="control-div">
                <label class="control-label">
                  <span class="pont-to">Point To</span>
                  <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                </label>
                @if (nodeFlowDetails) {
                  <next-selector [canEditFlows]="canEdit.canEditFlows"
                                 [selectorType]="'both'"
                                 [flowSteps]="nodeFlowDetails.currentFlowSteps"
                                 [flows]="nodeFlowDetails.flows"
                                 [name]="'no'"
                                 [form]="formGroup"
                                 [stepId]="nodeFlowDetails.stepId">
                  </next-selector>
                }
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
  </div>
}
